import React from 'react';
import intl from 'i18n/intl';
import { EAppId } from '@timeedit/types';
import Relations from '../examSettings/relations';

const language = intl.messages;

const RelationsSettingsPage = () => {
  return (
    <Relations
      appName={EAppId.TE_PREFERENCES}
      title={language.preferences_settings as string}
    />
  );
};

export default RelationsSettingsPage;
